import { TriggerEventType } from '@/constant/triggerEventType';

export const CART_RECOMMEND_SOURCE = 'cart_recommend_mvp';

export const CART_RECOMMEND_TARGET_SCENE = TriggerEventType.ADD_TO_CART;

/** 加购推荐引导默认模板（模板库 id=98） */
export const CART_RECOMMEND_TEMPLATE_ID = 98;

/** 弹窗类型：POP_WINDOW */
export const CART_RECOMMEND_CREATE_TYPE = 2;

export interface RecommendItem {
  id: string;
  scene: number;
  badge: string;
  titlePrefix: string;
  titleHighlight: string;
  descriptionLines: string[];
  primaryCta: string;
  secondaryCta: string;
}

export interface CartRecommendQualification {
  eligible: boolean;
  recommendationId?: string;
  targetScene?: number;
  experimentGroup?: string;
  items?: RecommendItem[];
}

export const DEFAULT_CART_RECOMMEND_ITEMS: RecommendItem[] = [
  {
    id: 'cart_recommend_mvp_1',
    scene: CART_RECOMMEND_TARGET_SCENE,
    badge: '推荐开启',
    titlePrefix: '加购却没结账的顾客，适合开启',
    titleHighlight: '【新客加购订阅弹窗】',
    descriptionLines: [
      '【目标用户】有购买意向，但未留下邮箱/手机号的用户',
      '【场景】精准提订阅、少打扰，弹窗只在用户加购后未结算时出现，不打断正常下单，购物车/结算页默认不出现',
    ],
    primaryCta: '预览并开启',
    secondaryCta: '暂不推荐',
  },
];
